<script>
import { Bubble, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Bubble,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    whiteBG: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  watch: {
    options: {
      handler() {
        this.$data._chart.destroy();
        this.renderChart(this.chartData, this.options);
      },
      deep: true
    }
  },
  mounted() {
    if (this.witheBG) {
      this.addPlugin({
        id: "test",
        beforeDraw: function(chart) {
          var ctx = chart.chart.ctx;
          ctx.fillStyle = "white";
          ctx.fillRect(0, 0, chart.chart.width, chart.chart.height);
          ctx.save();
        }
      });
    }
    this.renderChart(this.chartData, this.options);
  }
};
</script>
